import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";

import CSSModules from "react-css-modules";
import { CircularProgress } from "@material-ui/core";
import { Route, Switch } from "react-router";

import { Link } from "react-router-dom";
import TagLabelConfiguration from "../../../../components/TagLabelConfiguration/TagLabelConfiguration";

@CSSModules(styles, { allowMultiple: true })
class ImportStatusTags extends Component {


  constructor(props) {

    super(props);
    this.state = {
      id: props.match.params.id,
      label: props.match.params.label
    };
  }

  componentDidMount() {
    this.props.getData(this.state.id);
  }

  render() {

    if(this.props.isBusy === true)
      return <div class={"center-children full-height"}><CircularProgress /></div>;

    if(this.props.tagLabels == null || this.props.tagLabels.length === 0)
      return (
        <div class={"center-children margin-v-0"}>
          <span>There are no Tag Labels linked to this spreadsheet. This can be the case if the import failed or is still processing.</span>
        </div>
      );

    return (

      <div>

        <div style={{marginLeft: "0.5rem"}}>
          <h2>Imported Tag Labels</h2>
          <span>The following Tag Labels were imported from this spreadsheet upload. Select a tag to edit the configuration.</span>

        </div>

        <div class="key-config-split-container"
             style={{marginTop: "2rem"}}>

          {/* List of tag labels down the left */}
          <div class="key-column">
            <div>
              {this.props.tagLabels.map((x, i) => {
                return (
                  <div
                    class="key-entry"
                    status={x.configurationStatus}>
                    <Link to={`/MasterRules/Import/Status/${this.state.id}/TagLabels/${x.label}`}
                          key={i}>
                      <span>{x.label}</span>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Configuration data for selected tag label */}
          <div class="config-column">

            <Switch>
              <Route path={`/MasterRules/Import/Status/:id/TagLabels/:label`} component={TagLabelConfiguration} key={"import-status-tag" + this.state.label}></Route>
              <Route path={`/MasterRules/Import/Status/:id/TagLabels`}>
                <div className={"center-children full-height"}>
                  <span>Select a tag on the left to start configuration.</span>
                </div>
              </Route>
            </Switch>

          </div>

        </div>



      </div>

    );
  }

}

const bindAction = dispatch => {
  return {
    getData: (payload) => dispatch(actions.getData(payload))
  };
};

const mapStateToProps = state => ({
  tagLabels: state.importStatusTags.tagLabels,
  isBusy: state.importStatusTags.isBusy
});

export default connect(
  mapStateToProps,
  bindAction
)(ImportStatusTags);



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatusTags/ImportStatusTags.js